<style scoped>
</style>

<template>
  <div>
    <Card shadow v-if="tdata.current_data.length > 0">
      <div>
        <Button type="primary" @click="deleteSelection">取消关注</Button>
        <Table
          style="margin-top:10px"
          stripe
          :columns="tdata.col_data"
          :data="tdata.current_data"
          :loading="tdata.loading"
          @on-row-click="selectTableRow"
          @on-selection-change="selectChange"
        ></Table>
      </div>
    </Card>
    <h1 style="text-align:center;font-size:30px;margin:50px" v-else-if="hasRquest">当前暂未关注任何项目</h1>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hasRquest: false,
      selection: [],
      tdata: {
        keyword: "",
        //数据总量
        total: 0,
        //每页数量
        page_size: 15,
        //当前分页索引
        current_index: 1,
        //是否显示loading框
        loading: true,
        //当前表格数据
        current_data: [],
        //表头数据
        col_data: [
          {
            type: "selection",
            width: 60,
            align: "center",
          },
          {
            type: "index",
            width: 60,
            align: "center",
          },
          {
            title: "项目名称",
            key: "projectname",
          },
          {
            title: "项目经理",
            key: "pmname",
          },
          {
            title: "关注时间",
            key: "adddate",
          },
        ],
      },
    };
  },
  methods: {
    deleteSelection() {
      let ids = [];
      for (let i = 0; i < this.selection.length; i++) {
        ids.push(this.selection[i].id);
      }
      if (ids.length == 0) {
        this.$Message.warning("请选中至少一项");
        return;
      }

      let _this = this;
      this.$http.post({
        method: "mqms/project/attention/removebatch",
        params: ids,
        success: function (data) {
          _this.queryList();
        },
        failure(code, msg) {
          _this.$Message.warning({
            title: "提示",
            content: msg,
          });
        },
      });
    },
    selectChange(selection) {
      this.selection = selection;
    },
    queryList() {
      let _this = this;
      this.$http.get({
        method: "mqms/project/attention/attentionlist",
        params: {},
        success: function (data) {
          _this.tdata.current_data = data;
          _this.tdata.loading = false;
          _this.hasRquest = true;
        },
        failure(code, msg) {
          _this.$Message.warning({
            title: "提示",
            content: msg,
          });
        },
      });
    },
    selectTableRow(row) {
      // window.open("#/projectoverview/" + row.projectguid);
      this.$router.push({
        name: "projectoverview",
        params: { projectguid: row.projectguid },
      });
    },
  },
  mounted() {
    this.queryList();
  },
};
</script>